var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheme({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.75V5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.875H15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.875V4.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 3.125H11.875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9297 11.9219C15.7026 12.266 14.406 12.2772 13.1731 11.9545C11.9402 11.6318 10.8155 10.9868 9.91432 10.0856C9.01317 9.1845 8.36813 8.05973 8.04543 6.82684C7.72273 5.59396 7.734 4.2974 8.0781 3.07031C6.8683 3.40704 5.76785 4.05486 4.88633 4.94924C4.00482 5.84363 3.37303 6.95336 3.05387 8.16791C2.73472 9.38246 2.73934 10.6594 3.06729 11.8716C3.39524 13.0838 4.03507 14.189 4.92304 15.0769C5.81101 15.9649 6.91614 16.6047 8.12834 16.9327C9.34054 17.2606 10.6175 17.2653 11.8321 16.9461C13.0466 16.6269 14.1563 15.9951 15.0507 15.1136C15.9451 14.2321 16.5929 13.1317 16.9297 11.9219V11.9219Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.7286c08015e3dc473e61a92c3b4daa94.svg";
export { ForwardRef as ReactComponent };